import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authAPI } from '../services/api';

const AuthCallbackPage = ({ setUser }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const code = searchParams.get('code');
      const error = searchParams.get('error');

      if (error) {
        navigate('/login?error=' + error, { replace: true });
        return;
      }

      if (!code) {
        navigate('/login', { replace: true });
        return;
      }

      try {
        // Exchange temporary code for JWT token
        const user = await authAPI.exchange(code);
        if (setUser) setUser(user);

        // Check for pending checkout
        const pendingPlan = sessionStorage.getItem('pendingCheckoutPlan');
        if (pendingPlan) {
          sessionStorage.removeItem('pendingCheckoutPlan');
          navigate(`/pricing?checkout=${pendingPlan}`, { replace: true });
        } else {
          navigate('/', { replace: true });
        }
      } catch (err) {
        console.error('Auth callback error:', err);
        navigate('/login?error=exchange_failed', { replace: true });
      }
    };

    processAuth();
  }, [navigate, searchParams, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0a0f1a]">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-400">Connexion en cours...</p>
      </div>
    </div>
  );
};

export default AuthCallbackPage;
